export default "__VITE_IMAGE_ASSET__46a00545__";